// Small, SSR-safe environment probes. Each returns a safe default when `window`
// is missing or the API throws.

export const QUERIES = {
  motion: '(prefers-reduced-motion: no-preference)',
  reduce: '(prefers-reduced-motion: reduce)',
  fine: '(hover: hover) and (pointer: fine)',
  mobile: '(max-width: 767px)',
  desktop: '(min-width: 992px)',
} as const;

type NavigatorExtras = Navigator & {
  connection?: { saveData?: boolean; effectiveType?: string };
  deviceMemory?: number;
};

export function mq(query: string): boolean {
  try {
    return typeof window !== 'undefined' && window.matchMedia(query).matches;
  } catch {
    return false;
  }
}

export function prefersReducedMotion(): boolean {
  return mq(QUERIES.reduce);
}

export function hasFinePointer(): boolean {
  return mq(QUERIES.fine);
}

export function isMobileViewport(): boolean {
  return mq(QUERIES.mobile);
}

export function saveData(): boolean {
  try {
    const connection = (navigator as NavigatorExtras).connection;
    return !!connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType ?? '');
  } catch {
    return false;
  }
}

export function deviceMemory(): number | undefined {
  try {
    return (navigator as NavigatorExtras).deviceMemory;
  } catch {
    return undefined;
  }
}

export function queryFlag(name: string): boolean {
  try {
    return new URLSearchParams(location.search).get(name) === '1';
  } catch {
    return false;
  }
}
